import { Consts } from './consts'

export const User = {
  validateHaveCustomerSupport
}

function validateHaveCustomerSupport(roles) {
  return roles.includes(Consts.USER_ROLES_CUSTOMER_SUPPORT)
}
